import { AuthorizedUserParams, FilterValues } from '@/types'
// import { covidToggleOn } from '@/site.config'

const state = {
  tieredView: null,
  groupId: null,
  classId: null,
  classPlanId: null,
  framed: false,
  authParams: null as AuthorizedUserParams | null,
  decryptedParams: null as any | null,
  specialOffers: null as any | null,
  filters: null as FilterValues | null,
  legacyNetwork: false as Boolean,
  currentNetworkName: null,
  // covidToggleOn: covidToggleOn // master switch to covid logic + UI
}

const getters = {
  filters: state => state.filters,
  specialOffers: state => state.specialOffers,
  framed: state => state.framed as boolean,
  tieredView: state => state.tieredView as boolean,
  hideNetworkDropdown: (state, getters, rootState): boolean => {
    const networkDDDisabledFromQuery = state.authParams ? state.authParams.networkDDDisabled : 'false' as string
    const networkDDDisabledFromCMS = rootState.globals.microsite ? rootState.globals.microsite.networkDDDisabled : false as boolean
    return (
      networkDDDisabledFromQuery === 'true' ||
      networkDDDisabledFromQuery === 'yes' ||
      networkDDDisabledFromCMS === true
    )
  },
  packageId: state => state.authParams.packageId as string,
  legacyNetwork: state => state.legacyNetwork as Boolean
}

const mutations = {
  setFilters(state,filters):void {
     state.filters = filters
  },
  setSpecialOffers(state,specialOffers):void{
    state.specialOffers = specialOffers
  },
  setTieredView(state,tieredView): void{
    state.tieredView = tieredView
  },
  setFramed(state): void {
    state.framed = true
  },
  saveAuthParams(state, authParams): void {
    state.authParams = authParams as AuthorizedUserParams
  },
  setNetworkSetId(state, networkSetId): void {
    state.authParams.networkSetId = networkSetId;
  },
  saveDecryptedParams(state, decryptedParams): void {
    state.decryptedParams = decryptedParams
  },
  setLegacyNetwork(state, legacyNetwork: Boolean): void {
    state.legacyNetwork = legacyNetwork
  },
  setCurrentNetworkName(state, currentNetworkName: string): void {
    state.currentNetworkName = currentNetworkName
  }
}

const actions = {
  storeAuthParams({ commit }, authParams: AuthorizedUserParams) {
    commit('saveAuthParams', authParams)
  },
  setNetworkSetId({ commit }, networkSetId) {
    commit('setNetworkSetId', networkSetId);
  },
  storeDecryptedParams({ commit}, decryptedParams) {
    commit('saveDecryptedParams', decryptedParams)
  },
  storeLegacyNetwork({commit}, legacyNetwork: Boolean) {
    commit('setLegacyNetwork', legacyNetwork)
  },
  setCurrentNetworkName({ commit }, currentNetworkName:string) {
    commit('setCurrentNetworkName', currentNetworkName);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
